var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TabEditor',{attrs:{"tab":_vm.currTab,"app":_vm.currApp}})
}
var staticRenderFns = []

export { render, staticRenderFns }